<template>
  <v-app-bar
    elevation="0"
    class="main-header"
    height="64"
    fixed
    color='primary'
    dark>
    <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER">
      <template v-if="DRAWER_STATE">
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-arrow-left</v-icon>
      </template>
      <template v-else>
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-menu</v-icon>
      </template>
    </v-btn>
    <span style="width: 10px">&nbsp;</span>
    <v-img
      lazy-src="@/assets/accountxc_icon_logo.png"
      max-height="35"
      max-width="35"
      src="@/assets/accountxc_icon_logo.png"
    ></v-img>
    <span style="width: 10px">&nbsp;</span>
    <v-toolbar-title :class="$vuetify.theme.dark ? 'primary--text' : null">{{ !companyname ? 'AccountXC' : companyname }}</v-toolbar-title>
    <v-spacer></v-spacer>

    <Search />


    <v-menu
      min-width="180"
      offset-y
      bottom
      left
      nudge-bottom="10"
    >
      <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  v-if="userimage==''"
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  class="mr-3"
                  size="40">
                  <span class="white--text headline">{{ username[0].toUpperCase() }}</span>
                </v-avatar>
                <v-avatar
                  v-else
                  v-bind="attrs"
                  v-on="on"
                  class="mr-3"
                  size="40">
                  <img v-bind:src="userimage" alt="">
                </v-avatar>
      </template>
      <v-list >
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">{{ username }}</div>
        <div class="subtitle-2 primary--text font-weight-regular px-4">{{ useremail }}</div>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in account"
            :key="i"
            link
            @click="openLink(item.link, item.isBlank)"
          >
            <v-list-item-icon class="mr-4">
              <v-icon
                :color="item.color"
                v-text="item.icon"
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title color="greyTint" v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <div class="d-flex justify-center my-3">
          <v-btn
            width="80%"
            large
            outlined
            color="primary"
            class="text-capitalize"
            @click="logout"
          >Sign Out</v-btn>
        </div>
      </v-list>

    </v-menu>
    <div class="greeting-text mr-3 d-none d-md-block"><span>{{ username }}</span></div>

  </v-app-bar>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import config from '../../config';
  import Search from "@/components/Search/Search";

  export default {
    name: 'Header',
    components: { Search },
    data: () => ({
      config,
      username: undefined,
      useremail: undefined,
      userimage: undefined,
      companyname: undefined,
      searchCollapse: true,
      account: [
        { text: 'Company Policy', icon: 'mdi-circle-medium', color: 'greyTint', isBlank: true, link: '/companypolicy/view'},
        { text: 'My Claims', icon: 'mdi-circle-medium', color: 'greyTint', link: '/my/claim/list'  },
        { text: 'My Reimbursements', icon: 'mdi-circle-medium', color: 'greyTint', link: '/my/reimbursement/list' },
        { text: 'My Requests', icon: 'mdi-circle-medium', color: 'greyTint', link: '/my/request/list' },
        { text: 'My Statements', icon: 'mdi-circle-medium', color: 'greyTint', link: '/my/statement/list' },
      ],
      notificationsBadge: true,
      messageBadge: true
    }),
    computed: {
      ...mapState('Layout',
       { drawer: state => state.drawer }
      ),
      DRAWER_STATE :{
        get() {
          return this.drawer
        },
      }
    },
    methods: {
      ...mapActions('Layout', [ 'TOGGLE_DRAWER']),
      ...mapActions('Authentication', ['logoutUser']),
      ...mapActions('Department', ['clearDepartments']),
      ...mapActions('Location', ['clearLocations']),
      ...mapActions('SalesChannel', ['clearChannels']),
      openLink(link, isBlank) {
        console.log(link, isBlank)
        if(isBlank==true){
          let route = this.$router.resolve({path: link});
          window.open(route.href, '_blank');
        }
        else {
          this.$router.push({ path: link }).catch(()=>{});
        }
      },
      logout(){
        this.clearChannels();
        this.clearDepartments();
        this.clearLocations();
        this.logoutUser();
      }
    },
    created () {
      this.username = localStorage.getItem('username');
      this.useremail = localStorage.getItem('useremail');
      this.userimage = localStorage.getItem('userimage');
      this.companyname = localStorage.getItem('companyname');
    },
  };
</script>

<style src="./Header.scss" lang="scss"></style>
